import { DEFAULT_TIMEOUT } from '../config/constants.js';

/*
 * @forgerock/javascript-sdk
 *
 * timeout.ts
 *
 * Copyright (c) 2020 ForgeRock. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
/**
 * @module
 * @ignore
 * These are private utility functions
 */
function withTimeout(promise, timeout = DEFAULT_TIMEOUT) {
    const effectiveTimeout = timeout || DEFAULT_TIMEOUT;
    const timeoutP = new Promise((_, reject) => setTimeout(() => reject(new Error('Timeout')), effectiveTimeout));
    return Promise.race([promise, timeoutP]);
}

export { withTimeout };
